module.exports = __webpack_public_path__ + "img/44203e22df4b9d91a0c8b52f390b7855.png";